import { useLazyGetBranchesQuery, useUpdateBranchesMutation } from '@/api'
import { useContext, useReducer, useState } from 'react'
import type { BranchProps } from './types'
import { Box, CircularProgress, Collapse, IconButton } from '@mui/material'
import { styles } from '../../styles'
import type { IBranch } from '../../types'
import { useParams } from 'react-router-dom'
import { ChevronRightRounded } from '@mui/icons-material'
import { useDrawer, useRole } from '@/hooks'
import { OrganizationContext } from '@/modules/Organization/Organization'
import { PenEditIcon, TrashIcon } from '@/modules/MedComplex/icons'
import { DrawerType } from '@/store/app'

export const Branch = (props: BranchProps) => {
  const { branch, parent, setSelectedBranch, refreshParent } = props
  const { organizationId } = useParams()
  const { user } = useContext(OrganizationContext)
  const [getBranches, { data: branches }] = useLazyGetBranchesQuery()
  const [updateBranches] = useUpdateBranchesMutation()
  const [hidden, setHidden] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const { showDrawer } = useDrawer()
  const [hasChildren, setHasChildren] = useState(branch.hasChildren)

  const refreshBranch = () => {
    getBranches({
      companyId: Number(organizationId),
      params: {
        parentIds: Number(branch.id),
      },
    }).then((response) => {
      if (response.data.length === 0) {
        setHidden(true)
        setHasChildren(false)
        refreshParent()
      } else if (hidden) {
        setHasChildren(true)
        setHidden(false)
      }
    })
  }

  const handleGetBranches = () => {
    if (branches) {
      setHidden((prev) => !prev)
    } else if (organizationId && branch?.id) {
      setLoading(true)
      getBranches({
        companyId: Number(organizationId),
        params: {
          // ...(role !== 'Администратор Тетрон'
          //   ? {
          //       ids: user?.branches,
          //     }
          //   : {}),
          parentIds: Number(branch.id),
        },
      }).then(() =>
        setTimeout(() => {
          setHidden(false)
          setLoading(false)
        }, 500)
      )
    }
  }

  const handleEdit = () => {
    if (branches || !branch?.hasChildren) {
      setSelectedBranch({
        parent: branch,
        childs: branches,
        refresh: refreshBranch,
        refreshParent: refreshParent,
      })
      setTimeout(() => {
        showDrawer(DrawerType.EDIT_BRANCH)
      }, 100)
    } else if (organizationId && branch?.id) {
      setLoading(true)
      getBranches({
        companyId: Number(organizationId),
        params: {
          parentIds: Number(branch.id),
        },
      }).then(() => {
        setSelectedBranch({
          parent: branch,
          childs: branches,
          refresh: refreshBranch,
          refreshParent: refreshParent,
        })
        setTimeout(() => {
          showDrawer(DrawerType.EDIT_BRANCH)
          setHidden(false)
          setLoading(false)
        }, 500)
      })
    }
  }

  const handleDelete = () => {
    updateBranches({
      companyId: Number(organizationId),
      payload: {
        branches: [
          {
            id: branch.id,
            deleted: true,
          },
        ],
      },
    }).then(() => refreshParent())
  }

  return (
    <Box>
      <Box sx={styles.branch} className={'branch'}>
        <Box sx={styles.branch.title}>
          <Box>{branch?.name}</Box>
          {parent && <Box sx={styles.branch.parent}>{parent?.name}</Box>}
        </Box>
        <Box
          sx={{
            display: 'flex',
            margin: '-9px auto 0px 0px',
          }}
        >
          <IconButton
            sx={{
              justifySelf: 'center',
              '&.MuiButtonBase-root': {
                color: '#787878',
                minWidth: '38px',
              },
            }}
            onClick={handleEdit}
          >
            <PenEditIcon />
          </IconButton>
          <IconButton
            sx={{
              justifySelf: 'center',
              '&.MuiButtonBase-root': {
                color: '#787878',
                minWidth: '38px',
              },
            }}
            onClick={handleDelete}
          >
            <TrashIcon />
          </IconButton>
        </Box>
        {(branch?.hasChildren || hasChildren) && (
          <button onClick={handleGetBranches} style={{ alignSelf: 'flex-end' }}>
            {loading ? (
              <CircularProgress sx={{ color: '#787878' }} size={'17px'} />
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {hidden ? 'Развернуть' : 'Скрыть'}
                <ChevronRightRounded
                  sx={{
                    transform: hidden ? 'rotate(90deg)' : 'none',
                    transition: 'transform 0.2s ease-out',
                    height: '16px',
                    width: '16px',
                  }}
                />
              </Box>
            )}
          </button>
        )}
      </Box>
      {(branch?.hasChildren || hasChildren) && (
        <Collapse in={!hidden} sx={styles.branch.collapse}>
          {branches?.map((child_branch: IBranch) => (
            <Branch
              branch={child_branch}
              parent={branch}
              key={String(child_branch?.id)}
              setSelectedBranch={setSelectedBranch}
              refreshParent={refreshBranch}
            />
          ))}
        </Collapse>
      )}
    </Box>
  )
}
